<template>
	<Table class="table" :aria-label="'contacts list'">
		<ContactTableHeader
			:activeContacts="activeContacts"
			:currentPageLeadIds="currentPageLeadIds"
			:selectAllMode="selectAllMode"
			@getSortedContacts="setSort(true)"
		/>
		<ContactTableBody
			:activeContacts="activeContacts"
			:currentPageContacts="[...currentPageContacts]"
			:selectAllMode="selectAllMode"
		/>
	</Table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Table from '@/components/global/Table.vue';
import ContactTableHeader from './ContactTableHeader.vue';
import ContactTableBody from './ContactTableBody.vue';

export default {
	name: 'ContactsTable',
	components: {
		Table,
		ContactTableHeader,
		ContactTableBody,
	},
	props: {
		activeContacts: Boolean,
	},
	computed: {
		...mapState({
			selectAllMode: (state) => state.ccContacts.views.selectAllMode,
			currentPageContacts: (state) =>
				state.ccContacts.views.currentPageContacts,
		}),
		currentPageLeadIds() {
			return this.currentPageContacts.map((contact) => contact.leadId);
		},
	},
	methods: {
		...mapActions(['setSort']),
	},
};
</script>

<style lang="scss" scoped>
.table {
	background: $white;
}
</style>